var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.curLoginDialog)?[_c('login',{attrs:{"canClose":true}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"article_right_tab_container"}),_vm._v(" "),(_vm.curPriceDialog)?[_c('price',{attrs:{"code":_vm.priceCode,"show":true},on:{"close":function($event){_vm.curPriceDialog = false}}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb8053c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 